import { render, staticRenderFns } from "./nxTabs.vue?vue&type=template&id=75ce6d26&scoped=true&"
import script from "./nxTabs.vue?vue&type=script&lang=js&"
export * from "./nxTabs.vue?vue&type=script&lang=js&"
import style0 from "./nxTabs.vue?vue&type=style&index=0&id=75ce6d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ce6d26",
  null
  
)

export default component.exports